import Actor from "../../actors/Actor";
import common from "../../common";
export default class Dough extends Actor {
    constructor() {
        super();

        this.view = new PIXI.spine.Spine(P3.assets.spineData('dough'));
        this.view.position.set(0);
        this.view.scale.set(0.5);
        this.view.skeleton.setToSetupPose();
        this.view.skeleton.setSkin(null);
        this.view.skeleton.setSkinByName(this.determineDoughSkin());
        this.view.autoUpdate = false;
        this.view.update(0);
        this.addChild(this.view);
        this.view.stateData.defaultMix = 0.2;

        this._index = 1;

        this.view.state.addListener({
            complete: this._onAnimationComplete.bind(this),
            event: this._onAnimationEvent.bind(this)
        });
        this._finishedAnimating = new P3.utils.MiniSignal();

        if(common.doughIngredient)
            this.createIngredient();
        this.animate();
    }

    createIngredient(){
        this._ingredientView = new PIXI.spine.Spine(P3.assets.spineData('dough'));
        this._ingredientView.position.set(0);
        this._ingredientView.scale.set(0.5);
        this._ingredientView.skeleton.setToSetupPose();
        this._ingredientView.skeleton.setSkin(null);
        this._ingredientView.skeleton.setSkinByName(this.determineIngredientSkin());
        this._ingredientView.autoUpdate = false;
        this._ingredientView.update(0);
        this.addChild(this._ingredientView);

        this._ingredientView.stateData.defaultMix = 0.2;
    }

    update(dt, shouldUpdate = null) {
        if(!shouldUpdate) return;

        this.view.update(dt * 2);
        if(common.doughIngredient)
            this._ingredientView.update(dt * 2);

        if(!this._sound){
            let sounds = ['sfx_roll_dough_00', 'sfx_roll_dough_01'];
            this._sound = P3.audio.playSound(common.randomSelection(sounds),{
                destroyOnComplete: true,
                callback: ()=>{
                    this._sound = null;
                }
            });
        }
    }

    animate(){
        this.view.state.addAnimation(0, "roll_full", false, 0);
        if(common.doughIngredient)
            this._ingredientView.state.addAnimation(0, "roll_full", false, 0);

        this.view.update(P3.Ticker.dt * 2);
        if(common.doughIngredient)
            this._ingredientView.update(P3.Ticker.dt * 2);

        // this.playRollAnimation(this.view);
        // if(common.doughIngredient)
        //     this.playRollAnimation(this._ingredientView);
        // this._index++;
    }

    playRollAnimation(view){
        if(this._index < 5){
            view.state.addAnimation(0, "roll_" + this._index, false, 0);
        }
    }

    determineDoughSkin(){
        let colour = common.doughColour || "";
        //console.log(colour);
        let map = new Map();
        map.set('dough_lemon', Dough.LEMON);
        map.set('dough_orange', Dough.ORANGE);
        map.set('dough_plain', Dough.WHITE);
        map.set('dough_strawberry', Dough.STRAWBERRY);

        let col = null;
        map.forEach((v,k) => {
            if(v === colour.toString()){
                col = k;
            }
        });
        return col || 'dough_plain';
    }

    determineIngredientSkin(){
        let colour = common.doughIngredient || "";
        //console.log(colour);
        let map = new Map();
        map.set('ing_white_choc', Dough.WHITE);
        map.set('ing_dark_choc', Dough.DARK);
        map.set('ing_rasins', Dough.RAISEN);
        map.set('ing_strawberries', Dough.STRAWBERRY);

        let col = null;
        map.forEach((v,k) => {
            if(v === colour.toString()){
                col = k;
            }
        });
        return col || 'ing_dark_choc';
    }

    _onAnimationComplete(entry) {
        const name = entry.animation.name;
        if (["roll_4"].indexOf(name) !== -1) {
            this._finishedAnimating.dispatch();
        }

        if (["roll_full"].indexOf(name) !== -1) {
            this._finishedAnimating.dispatch();
        }
    }

    _onAnimationEvent(entry, event) {
    }
}
Dough.DARK = "0xBC8971";
Dough.WHITE = "0xFDF4C6";
Dough.RAISEN = "0xBC8970";
Dough.ORANGE = "0xFFB648";
Dough.LEMON = "0xFFEA57";
Dough.STRAWBERRY = "0xFF9D9B";